module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/agents-5bf5692d4280f054e1e2991d97211df2.svg";